module.exports = __webpack_public_path__ + "img/done-icon.62d4d524.svg";